import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/import-5c0d2803.js';
import { f as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/import-d09f487d.js';
import { f as focusOutlineMixin } from '../FocusIndicator/styleMixins/focusOutline-ae6f4c7f.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';
import { I as Icon } from '../Icon/Icon-fb1c95bc.js';
import { g as getPadding } from '../LocalModules/storm-ui-utils/dist/esm/getPadding-2fd7f7a3-291a9726.js';
import { d as deviceTypes } from '../LocalModules/storm-ui-utils/dist/esm/deviceTypes-76b869e3-9b9b478e.js';

const DiscloseIcon = /*#__PURE__*/styled(Icon).attrs({
  size: 'lg'
}).withConfig({
  componentId: "sc-storm-ui-30037988__sc-1cwd7be-0"
})(["flex:0 0 auto;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-content:center;align-items:center;height:", ";margin-inline-end:", ";color:", ";"], ({
  theme
}) => theme.spacing.xlarge, ({
  theme
}) => theme.spacing.mini, ({
  theme
}) => theme.palette.gray[800]);
DiscloseIcon.displayName = 'DiscloseIcon';
const cardHeaderTypography = /*#__PURE__*/css([">h1{", "}>h2{", "}>h3{", "}>h4{", "}>h5{", "}>h6{", "}"], ({
  theme
}) => theme.typography.h1, ({
  theme
}) => theme.typography.h2, ({
  theme
}) => theme.typography.h3, ({
  theme
}) => theme.typography.h4, ({
  theme
}) => theme.typography.h5, ({
  theme
}) => theme.typography.h6);
const CardHeaderContentStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30037988__sc-1cwd7be-1"
})(["flex:1 1 auto;", ""], cardHeaderTypography);
CardHeaderContentStyled.displayName = 'CardHeaderContentStyled';
const cardHeaderStyles = /*#__PURE__*/css(["background:", ";padding:", "px;text-align:start;border:none;border-bottom:", ";border-radius:", ";", ""], ({
  theme
}) => theme.card.header.bg, ({
  theme,
  padding
}) => getPadding(theme, padding), ({
  theme,
  isCollapsed
}) => isCollapsed ? 'none' : theme.card.header.borderBottom, ({
  theme,
  isCollapsed
}) => isCollapsed ? theme.card.header.borderRadius : `${theme.card.header.borderRadius} ${theme.card.header.borderRadius} 0 0`, isMobile(css(["padding:", "px;"], ({
  theme,
  padding
}) => getPadding(theme, padding, deviceTypes.MOBILE))));
const CollapsibleCardHeaderStyled = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30037988__sc-1cwd7be-2"
})(["", " cursor:pointer;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:flex-start;align-items:center;outline:none;color:", ";> ", "{@media (prefers-reduced-motion:no-preference){transition:all 0.15s ease-in-out;}", ";}", " :focus{", "}"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => {
  var _theme$typography;
  return (_theme$typography = theme.typography) === null || _theme$typography === void 0 || (_theme$typography = _theme$typography.color) === null || _theme$typography === void 0 ? void 0 : _theme$typography.base;
}, DiscloseIcon, ({
  isCollapsed
}) => isCollapsed ? '/*! @noflip */ transform: rotate(180deg)' : '', cardHeaderStyles, ({
  focusVisible
}) => focusVisible && focusOutlineMixin);
CollapsibleCardHeaderStyled.displayName = 'CollapsibleCardHeaderStyled';
const CardHeaderStyled = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30037988__sc-1cwd7be-3"
})(["", " ", ""], cardHeaderStyles, cardHeaderTypography);
CardHeaderStyled.displayName = 'CardHeaderStyled';

export { CollapsibleCardHeaderStyled as C, DiscloseIcon as D, CardHeaderContentStyled as a, CardHeaderStyled as b };
//# sourceMappingURL=CardHeader.styles-02a08707.js.map
